import React from 'react'

export const TextParser = ({ text }) => {
  if (!text) return null

  const handleBoldTags = (parts) => {
    return parts.map((part, index) => {
      if (part.startsWith('<b>') && part.endsWith('</b>')) {
        return <strong key={index}>{part.slice(3, -4)}</strong>
      }
      return part
    })
  }

  const handleItalicTags = (parts) => {
    return parts.flatMap((part, index) => {
      if (typeof part === 'string') {
        const italicParts = part.split(/(<i>.*?<\/i>)/g)
        return italicParts.map((italicPart, italicIndex) => {
          if (italicPart.startsWith('<i>') && italicPart.endsWith('</i>')) {
            return <em key={`${index}-${italicIndex}`}>{italicPart.slice(3, -4)}</em>
          }
          return italicPart
        })
      }
      return part
    })
  }

  const handleAnchorTags = (parts) => {
    return parts.flatMap((part, index) => {
      if (typeof part === 'string') {
        const anchorParts = []
        let lastIndex = 0
        const regex = /<a href="([^"]+)">([^<]+)<\/a>/g
        let match

        while ((match = regex.exec(part)) !== null) {
          if (match.index > lastIndex) {
            anchorParts.push(part.substring(lastIndex, match.index))
          }

          const href = match[1]
          const linkText = match[2]
          anchorParts.push(
            <a key={`${index}-${match.index}`} href={href}>
              {linkText}
            </a>
          )

          lastIndex = match.index + match[0].length
        }

        if (lastIndex < part.length) {
          anchorParts.push(part.substring(lastIndex))
        }

        return anchorParts.length > 0 ? anchorParts : part
      }
      return part
    })
  }

  const boldSplit = text.split(/(<b>.*?<\/b>)/g)
  const boldProcessed = handleBoldTags(boldSplit)
  const italicProcessed = handleItalicTags(boldProcessed)
  const allProcessed = handleAnchorTags(italicProcessed)

  return (
    <>
      {allProcessed.map((part, index) => {
        if (typeof part === 'string' && part.trim() === '') {
          return null
        }
        if (typeof part === 'string') {
          return <span key={index}>{part}</span>
        }
        return part
      })}
    </>
  )
} 